import { useCurrentFrame, interpolate, useVideoConfig, AbsoluteFill } from "remotion";

// Variant 2 — Gold divine glow, pulsing border
export const ReelCTA2: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const fadeIn  = interpolate(frame, [0, 5], [0, 1], { extrapolateRight: "clamp" });
  const fadeOut = interpolate(frame, [Math.round(fps*2.5), Math.round(fps*3)], [1, 0], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  const pulse   = 0.88 + Math.sin(frame * 3.1) * 0.12;
  const glow    = 16 + Math.sin(frame * 2.2) * 8;
  const scale   = interpolate(frame, [0, 4], [0.85, 1], { extrapolateRight: "clamp", extrapolateLeft: "clamp" });
  return (
    <AbsoluteFill style={{ pointerEvents: "none" }}>
      <div style={{ position:"absolute", bottom:"18%", left:"50%", transform:`translateX(-50%) scale(${scale})`, opacity: fadeIn*fadeOut, whiteSpace:"nowrap" }}>
        <div style={{ background:"linear-gradient(135deg,rgba(20,12,0,0.92),rgba(40,25,0,0.92))", borderRadius:8, padding:"10px 22px", border:`1.5px solid rgba(255,210,60,${pulse})`, boxShadow:`0 0 ${glow}px rgba(255,190,0,0.55),0 4px 24px rgba(0,0,0,0.8)`, display:"flex", alignItems:"center", gap:10 }}>
          <svg width="14" height="12" viewBox="0 0 18 14"><polygon points="0,0 18,7 0,14" fill="#FFD700" /></svg>
          <span style={{ color:"#FFD700", fontSize:27, fontWeight:900, fontFamily:"'Arial Black','Impact',sans-serif", letterSpacing:"0.06em", textShadow:`0 0 ${glow}px rgba(255,210,0,0.7),0 2px 6px rgba(0,0,0,0.9)` }}>WATCH FULL VIDEO</span>
        </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
